import React from 'react'
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "@studio-freight/lenis";
import { useEffect } from 'react';
import "../styles/website.css"
import { Link, useNavigate } from 'react-router-dom';
import FAQ from '../components/Faqs';
import testimonial from "../assets/img/testimonial/it3.jpg"
import testimonial1 from "../assets/img/testimonial/it2.jpg"
import testimonial2 from "../assets/img/testimonial/it1.jpg"
import testimonial3 from "../assets/img/testimonial/it.jpg"
 
 import heroImg from '../assets/img/invoices/i.png';
import "../styles/digitalMarketing.css"
import { IoIosArrowRoundDown } from "react-icons/io";
  import CaseStudyGallery from '../components/CaseStudyGallery';
 import InvoiceTimeline from '../components/InvoiceTimeline';
 import { FaBuilding, FaHospital, FaUniversity, FaShoppingCart, FaTruck, FaLaptop } from "react-icons/fa";
import "../styles/trustedWrapper.css"
import "../styles/invoice.css"
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import InvoiceFAQs from '../components/InvoiceFAQS';

const Invoice = () => {

 
  

    const navigate = useNavigate();
  
  
  const handleContactBtn = () => {
    navigate("/get-in-touch")
  }
  

  return (
    <>
<section className="website-wrapper invoice">
    
 <Nav/>
 
<section className="hero">
  <div className="hero-content">
    <span className="hero-subtitle">Invoice Generator</span>
    <h1>
      Create, Send, and Track <em>Professional Invoices</em> in Minutes
    </h1>

    <p>
      Design branded invoices, accept secure payments, and manage your billing process effortlessly, all in one simple platform.
    </p>
    <a href="#about" className="hero-discover">
      Discover more <span className="arrow"><IoIosArrowRoundDown /></span>
    </a>
  </div>
  <div className=" invoice__hero-img">
    <img src={heroImg} alt="Invoice creation illustration" />
  </div>
</section>


  <InvoiceTimeline/>
 
<section className='trusted__wrapper-container'>
<section className="trusted-wrapper">
  <div className="trusted-content">
    <h2>Trusted by Businesses Across Many Industries</h2>
    <p>
      Our invoice generator is used by professionals, entrepreneurs, and enterprises to streamline billing and get paid faster.
    </p>

    <div className="trusted-grid">
      <div className="trusted-item">
        <FaBuilding className="trusted-icon icon-yellow" />
        <span>Real Estate</span>
      </div>
      <div className="trusted-item">
        <FaHospital className="trusted-icon icon-red" />
        <span>Healthcare</span>
      </div>
      <div className="trusted-item">
        <FaUniversity className="trusted-icon icon-blue" />
        <span>Education</span>
      </div>
      <div className="trusted-item">
        <FaShoppingCart className="trusted-icon icon-green" />
        <span>Retail & E-commerce</span>
      </div>
      <div className="trusted-item">
        <FaTruck className="trusted-icon icon-orange" />
        <span>Logistics</span>
      </div>
      <div className="trusted-item">
        <FaLaptop className="trusted-icon icon-purple" />
        <span>Freelancers & Agencies</span>
      </div>
    </div>
  </div>
</section> 
 
</section>
   


   

   

  <InvoiceFAQs/>



</section>

<section className="client-testimonials">
  <h3>
    What our clients have said <br />
    <span>about our Invoice Generator</span>
  </h3>

  <div className="testimonial-cards">
    {/* Freelancer */}
    <div className="testimonial-card">
      <p className="quote">
        “Creating invoices used to take me forever, but now I generate them in
        minutes. My clients love the professional look, and I get paid faster.”
      </p>
      <div className="client-info">
        <img
          src={testimonial}
          alt="Kevin Mwangi"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Kevin Mwangi</p>
          <p className="client-title">Freelance Graphic Designer — Nairobi</p>
        </div>
      </div>
    </div>

    {/* SME Business Owner */}
    <div className="testimonial-card">
      <p className="quote">
        “The invoice generator has streamlined our billing. Tracking paid and
        pending invoices is now so simple, and our records are always
        organized.”
      </p>
      <div className="client-info">
        <img
          src={testimonial1}
          alt="Grace Atieno"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Grace Atieno</p>
          <p className="client-title">Owner — Lakeview Supplies, Kisumu</p>
        </div>
      </div>
    </div>

    {/* Consultant */}
    <div className="testimonial-card">
      <p className="quote">
        “I work with international clients, and being able to invoice in
        different currencies has been a game changer. It makes me look
        professional and saves me time.”
      </p>
      <div className="client-info">
        <img
          src={testimonial2}
          alt="Ahmed Noor"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Ahmed Noor</p>
          <p className="client-title">IT Consultant — Mombasa</p>
        </div>
      </div>
    </div>

    {/* NGO / Nonprofit */}
    <div className="testimonial-card">
      <p className="quote">
        “Managing donor receipts and partner payments is now seamless. The
        reporting tools give us clarity and transparency for every project.”
      </p>
      <div className="client-info">
        <img
          src={testimonial3}
          alt="Linda Wambui"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Linda Wambui</p>
          <p className="client-title">Finance Manager — Hope Foundation Kenya</p>
        </div>
      </div>
    </div>
  </div>
</section>



<section className="booking-wrapper">
  <div className="booking-content">
    <h3>Let's get to work</h3>
    <p>Ready to get started? Book a Discovery Call so we can learn more about your needs and discuss how we can help.</p>
    <button className="get-started-btn" onClick={handleContactBtn}>
      Get Started <span className="plus-icon">+</span>
    </button>
  </div>
   
</section>

<Footer/>  
</>

  )
}

export default Invoice